<template>
  <div class="swhitech-container">
    <div class="padded-container position-relative" style="height: 100vh;">
      <!-- 왼쪽 위 텍스트 -->
      <div class="text-top-left">
        <object data="/static_img/main_pages/swhitech/left-top-text.svg" type="image/svg+xml" aria-label="Left Top Text" ></object>
      </div>

      <!-- 오른쪽 아래 텍스트 -->
      <div class="text-bottom-right">
       <object data="/static_img/main_pages/swhitech/right-bottom-image-text.svg" type="image/svg+xml" aria-label="Right Bottom Image Text"></object>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StoryBoardMain',
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&display=swap');

.swhitech-container {
  position: relative;
  width: 100%;
  height: 100vh;
  background-color: #86D3FF;
  overflow: hidden;
}

.text-top-left {
  position: absolute;
  top: calc(10vh + 90px);
  width: 50vw;
  font-family: 'Roboto Condensed', sans-serif;
  z-index: 10;
  max-width: 600px;
  min-width: 300px;

  object {
    width: 100%;
    height: auto;
    pointer-events: none;
  }
}

.text-bottom-right {
  position: absolute;
  bottom: 5vh;
  right: clamp(20px, 5vw, 50px);
  font-family: 'Roboto Condensed', sans-serif;
  z-index: 10;
  width: clamp(50vw, 800px, 90vw); ;
  min-width: 400px;
  max-width: 1500px;

  object {
    width: 100%;
    height: auto;
    pointer-events: none;
  }
}
</style>
